import React from 'react';
export const CFIconCollapse = {
    alias: 'collapse',
    defaultTitle: 'Collapse',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M16.415 9H19a1 1 0 0 1 0 2l-4.976-.003a1 1 0 0 1-1-.995L13 5.005A1 1 0 0 1 13.995 4H14a1 1 0 0 1 1 .995l.012 2.578 3.28-3.28a1 1 0 1 1 1.415 1.414L16.415 9Zm-11.41 4 4.996.025a1 1 0 0 1 .995.999L11 19a1.001 1.001 0 0 1-2 .002l-.002-2.585-3.29 3.291a1 1 0 0 1-1.415-1.414l3.28-3.28-2.578-.013a1 1 0 0 1 .005-2h.004Z' }))),
};
